module.exports = __webpack_public_path__ + "gr.0a3606252bb45dd36013.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/4x3/gr.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/4x3/gr.svg
// module chunks = styles